import React, { useEffect, useRef } from 'react';
import { useMediaPlayerStore } from '../../stores/useUIStore';

const GlobalMediaPlayer = () => {
  const isOpen = useMediaPlayerStore((state) => state.isOpen);
  const media = useMediaPlayerStore((state) => state.media);
  const closePlayer = useMediaPlayerStore((state) => state.closePlayer);
  const videoRef = useRef(null);

  useEffect(() => {
    // Pausar el video cuando se cierra el modal
    if (!isOpen && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isOpen]);

  if (!isOpen || !media) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]"
      onClick={closePlayer}
    >
      <div className="relative bg-black rounded-lg shadow-2xl w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
        <button onClick={closePlayer} className="absolute -top-10 right-0 text-white text-3xl font-bold hover:text-gray-300">&times;</button>
        {media.type === 'video' && <video ref={videoRef} src={media.url} controls autoPlay className="w-full rounded-lg" />}
      </div>
    </div>
  );
};

export default GlobalMediaPlayer;